import {Group, GroupedData} from "../../../data-structures/group"
import FieldProto from "../../../fields3/proto/field-proto"
import {SEPARATOR} from "../../../gd-components/popover-menu/const"

export type FieldSelectorConfig = {
    groupedFields   : GroupedData;        // For grouped fields list
    allFields       : FieldProto[]        // For search
}


export default function convertFieldsStructureToConfig(fieldsStructure:GroupedData): FieldSelectorConfig {

    const groupedFields: GroupedData = []

    const allFields: FieldProto[] = []

    _.map(fieldsStructure, (group:Group)=> {

        const fields : any[] = [] // FieldProto[] | {fieldId: SEPARATOR}[]

        let previousIsSeparator: boolean = false // to prevent multiple separators placed consistently
        _.map(group.items, (item:FieldProto|typeof SEPARATOR)=>{

            if (!item) {
                console.log("Error #9832 ", item)
                return
            }

            if (item === SEPARATOR) {
                if (!previousIsSeparator) {
                    fields.push({fieldId: SEPARATOR}) // micro hack for Field selector fields list
                }
                previousIsSeparator = true
            } else {
                fields.push(item)
                previousIsSeparator = false
                allFields.push(item)
            }
        })

        groupedFields.push({
            value           : group.value,
            label           : group.label,
            type            : group.type,
            items           : fields
        })
    })

    return {
        groupedFields   : groupedFields,
        allFields       : allFields
    }

}
